// extracted by mini-css-extract-plugin
module.exports = {"container":"Alert_container__XFqIr","dismiss":"Alert_dismiss__UtAPT","alert":"Alert_alert__KsrUE","fadeOut":"Alert_fadeOut__axvPv"};